function i(t) {
  return t > 0 && t < 100;
}
function o(t) {
  return t >= 100;
}
function c(t) {
  return t <= 0;
}
function f({ thickness: t, width: e } = {}) {
  return t ? (t / e * 100).toFixed(1) : (15 * (e / 200) / e * 100).toFixed(1);
}
function u({ strokeWidth: t, width: e }) {
  return (t / e * 100).toFixed(1);
}
function s(t) {
  return t >= 0 && t < 20 ? 10 : t >= 20 && t < 50 ? 4 : t >= 50 && t < 80 ? 2 : t >= 80 && t < 99 ? 0.5 : 0;
}
const E = /* @__PURE__ */ function() {
  const t = [];
  function e() {
    const n = t.shift();
    n && n(e);
  }
  return function(n) {
    t.push(n), t.length === 1 && e();
  };
}();
export {
  u as getRelativeStrokeWidth,
  f as getRelativeThickness,
  s as getTrickleProgress,
  o as isComplete,
  i as isInProgress,
  c as isNotStarted,
  E as queue
};
//# sourceMappingURL=utils.js.map
